import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, fetchWithEnvelope, setHeaderOptions } from "./apiHelpers";
import {
  ContractSessionResponse,
  ContractSignRequest,
  ContractSignResponse,
  UserContract,
  userContractsApiResponseSchema,
} from "./contracts.type";

export async function getContractSession(
  idOrSlug: string
): Promise<ContractSessionResponse> {
  const slug = `${ApiEndpoints.contracts}/${encodeURIComponent(
    idOrSlug
  )}/session`;
  const options = await setHeaderOptions({ method: "GET" });
  const res = await fetchWithEnvelope<
    ContractSessionResponse | { data: ContractSessionResponse }
  >(slug, options);
  return (
    (res as { data?: ContractSessionResponse })?.data ||
    (res as ContractSessionResponse)
  );
}

export async function postContractSign(
  body: ContractSignRequest
): Promise<ContractSignResponse> {
  // New unified sign endpoint: POST /api/contracts/sign
  const slug = `${ApiEndpoints.contracts}/sign`;
  const options = await setHeaderOptions({ method: "POST", body });
  const res: any = await fetchData<any>(slug, options);
  return (res?.data ?? res) as ContractSignResponse;
}

// Lists the authenticated user's contract requests. User is derived from auth token.
type GetUserContractRequestOptions = {
  userId?: string;
  includeAll?: boolean;
};

export async function getUserContractRequests(
  options?: GetUserContractRequestOptions
): Promise<UserContract[]> {
  const params = new URLSearchParams();
  if (options?.includeAll) {
    params.set("all", "true");
  }
  if (options?.userId) {
    params.set("user_id", options.userId);
  }
  const query = params.toString();
  const slug = `${ApiEndpoints.contracts}${query ? `?${query}` : ""}`;
  const requestOptions = await setHeaderOptions({ method: "GET" });
  const res: any = await fetchData<any>(slug, requestOptions);
  const parsed = userContractsApiResponseSchema.safeParse(res?.data ?? res);
  if (!parsed.success) {
    // Fallback: return empty list on parse error
    return [];
  }
  return Array.isArray(parsed.data)
    ? (parsed.data as UserContract[])
    : ((parsed.data as any).items as UserContract[]);
}
